import type { ClientMsg, ServerMsg } from '@shared/protocol';

export type InitMsg = Extract<ServerMsg, { t: 'init' }>;

/** WebSocket connection to one world room. */
export class Connection {
  onMessage: ((msg: ServerMsg) => void) | null = null;
  onClose: ((event: CloseEvent) => void) | null = null;

  private constructor(private readonly ws: WebSocket) {}

  /** Opens the socket and resolves once the server sends the init snapshot. */
  static connect(worldId: number): Promise<{ connection: Connection; init: InitMsg }> {
    return new Promise((resolve, reject) => {
      const proto = location.protocol === 'https:' ? 'wss' : 'ws';
      const ws = new WebSocket(`${proto}://${location.host}/ws/${worldId}`);
      const connection = new Connection(ws);
      let initialized = false;

      ws.onmessage = (e) => {
        const msg = JSON.parse(e.data as string) as ServerMsg;
        if (!initialized) {
          if (msg.t !== 'init') return;
          initialized = true;
          resolve({ connection, init: msg });
        } else {
          connection.onMessage?.(msg);
        }
      };
      ws.onclose = (e) => {
        if (!initialized) reject(new Error(`connection failed (${e.code})`));
        else connection.onClose?.(e);
      };
    });
  }

  send(msg: ClientMsg): void {
    if (this.ws.readyState === WebSocket.OPEN) this.ws.send(JSON.stringify(msg));
  }
}
